import { useContext, useEffect, useState } from "react";
import { Col, Row } from "react-bootstrap";
import LoadingSpinner from "../../../components/LoadinSpinner";
import TitlePage from "../../../components/TitlePage";
import ResponsiveDataTable from "../../../components/DataTable";
import { useNavigate } from "react-router-dom";
import { SucessoMsg } from "../../../contents/VariaveisGlobais";
import { ThemeContext } from "../../../../App";
import axios from 'axios';
import { usePopUp } from "../../../components/BootBox";

function ListaPerfilUsuario() {
    var [carregar, setCarregar] = useState(false);
    const { DisparaBootBox, FechaBootBox  } = usePopUp();
    const [ perfilUsuario, setPerfilUsuario ] = useState();
    const [ dataGrid, setDataGrid ] = useState([]);
    const navigate = useNavigate();
    
    const columns = [
        {
          Header: 'ID',
          accessor: 'idPerfil',
        },
        {
          Header: 'Descrição Perfil',
          accessor: 'perfil',
        }
    ]

    useEffect(() => {
        const fetchData = async () => {
			try {
				// Construct the public URL for the JSON file
				const jsonUrl = "/lib/perfilUsuario.json";
                
				const response = await axios.get(jsonUrl, {
					headers: {
						'Cache-Control': 'no-cache, no-store, must-revalidate',
						'Pragma': 'no-cache',
						'Expires': '0',
					},
				});
				
				const data = await response.data;
				
				// Set the data in the component's state
				setPerfilUsuario(data);
                setDataGrid(data.perfil)
				} catch (error) {
				console.error('Error fetching JSON:', error);
			}
		};
	
		fetchData();
    }, []);

    const handleAlterar = (row) =>{
        navigate(`./Alterar/${row.values.idPerfil}`)
    }

    const handleExcluir = async (row) => {
        const idRow = row.values.idPerfil;
        const Mensagem = `Tem certeza que deseja excluir o registro ${idRow + ' - ' + row.values.perfil}?`
        
        DisparaBootBox('Confirma Exclusão ?', Mensagem, null, idRow, handleExcluirConfirm)
    };

    const handleExcluirConfirm = async(id) => {
        FechaBootBox()
        try {
            setCarregar(true);
            // const rota = 'perfilUsuario/' + id;
            // const retConsumo = await ConsumoAPI_DELETE(rota);
            SucessoMsg("Excluído com Sucesso!");
            // var data = perfilUsuario.perfil
        } catch (error) {
            console.error('Error in handleExcluir:', error);
            // Handle the error, show an error message, or log it as needed.
        } finally {
            setCarregar(false);
        }
    };
    
    return (
    <>
        <Row>
            <LoadingSpinner isLoading={carregar}/>
            <Col md="12" xs="12">
                <TitlePage text="Perfil de Usuário"/>
            </Col>
            { dataGrid.length > 0 &&
                <Col md="12" xs="12">
                    <ResponsiveDataTable 
                        columns={columns} 
                        data={dataGrid} 
                        buttons= {[
                                {isAlterar: true, action: handleAlterar, label: "Alterar", icone: "MdOutlineEditNote"}, 
                                {isExcluir: true, action: handleExcluir, label: "Excluir", icone: "MdPlaylistRemove", style: "danger"}
                        ]}
                    />
                </Col>
            }
        </Row>
        </>
    );
}

export default ListaPerfilUsuario;